/**
 * Asynchronously loads the component for ResetPasswordPage
 */

import { lazyLoad } from 'utils/loadable';

export const GenerateTemplatesPage = lazyLoad(
  () => import('./index'),
  module => module.GenerateTemplatesPage,
);
